import { render } from "./modalsContainer.vue?vue&type=template&id=979ca0bc&scoped=true&ts=true"
import script from "./modalsContainer.vue?vue&type=script&lang=ts"
export * from "./modalsContainer.vue?vue&type=script&lang=ts"

import "./modalsContainer.vue?vue&type=style&index=0&id=979ca0bc&scoped=true&lang=css"
import "./modalsContainer.vue?vue&type=style&index=1&id=979ca0bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-979ca0bc"]])

export default __exports__